const position = [
  "top-left",
  "top-center",
  "top-right",
  "bottom-left",
  "bottom-center",
  "bottom-right"
] as const

const swipeDirection = [
  "up",
  "right",
  "down",
  "left"
] as const

export default {
  "slots": {
    "viewport": "tw:fixed tw:flex tw:flex-col tw:w-[calc(100%-2rem)] tw:sm:w-96 tw:z-[100] tw:data-[expanded=true]:h-(--height) tw:focus:outline-none",
    "base": "tw:pointer-events-auto tw:absolute tw:inset-x-0 tw:z-(--index) tw:transform-(--transform) tw:data-[expanded=false]:data-[front=false]:h-(--front-height) tw:data-[expanded=false]:data-[front=false]:*:opacity-0 tw:data-[front=false]:*:transition-opacity tw:data-[front=false]:*:duration-100 tw:data-[state=closed]:animate-[toast-closed_200ms_ease-in-out] tw:data-[state=closed]:data-[expanded=false]:data-[front=false]:animate-[toast-collapsed-closed_200ms_ease-in-out] tw:data-[state=open]:data-[pulsing=odd]:animate-[toast-pulse-a_300ms_ease-out] tw:data-[state=open]:data-[pulsing=even]:animate-[toast-pulse-b_300ms_ease-out] tw:data-[swipe=move]:transition-none tw:transition-[transform,translate,height] tw:duration-200 tw:ease-out"
  },
  "variants": {
    "position": {
      "top-left": {
        "viewport": "tw:left-4"
      },
      "top-center": {
        "viewport": "tw:left-1/2 tw:transform tw:-translate-x-1/2"
      },
      "top-right": {
        "viewport": "tw:right-4"
      },
      "bottom-left": {
        "viewport": "tw:left-4"
      },
      "bottom-center": {
        "viewport": "tw:left-1/2 tw:transform tw:-translate-x-1/2"
      },
      "bottom-right": {
        "viewport": "tw:right-4"
      }
    },
    "swipeDirection": {
      "up": "tw:data-[swipe=end]:animate-[toast-slide-up_200ms_ease-out]",
      "right": "tw:data-[swipe=end]:animate-[toast-slide-right_200ms_ease-out]",
      "down": "tw:data-[swipe=end]:animate-[toast-slide-down_200ms_ease-out]",
      "left": "tw:data-[swipe=end]:animate-[toast-slide-left_200ms_ease-out]"
    }
  },
  "compoundVariants": [
    {
      "position": [
        "top-left" as typeof position[number],
        "top-center" as typeof position[number],
        "top-right" as typeof position[number]
      ],
      "class": {
        "viewport": "tw:top-4",
        "base": "tw:top-0 tw:data-[state=open]:animate-[toast-slide-in-from-top_200ms_ease-in-out]"
      }
    },
    {
      "position": [
        "bottom-left" as typeof position[number],
        "bottom-center" as typeof position[number],
        "bottom-right" as typeof position[number]
      ],
      "class": {
        "viewport": "tw:bottom-4",
        "base": "tw:bottom-0 tw:data-[state=open]:animate-[toast-slide-in-from-bottom_200ms_ease-in-out]"
      }
    },
    {
      "swipeDirection": [
        "left" as typeof swipeDirection[number],
        "right" as typeof swipeDirection[number]
      ],
      "class": "tw:data-[swipe=move]:translate-x-(--reka-toast-swipe-move-x) tw:data-[swipe=end]:translate-x-(--reka-toast-swipe-end-x) tw:data-[swipe=cancel]:translate-x-0"
    },
    {
      "swipeDirection": [
        "up" as typeof swipeDirection[number],
        "down" as typeof swipeDirection[number]
      ],
      "class": "tw:data-[swipe=move]:translate-y-(--reka-toast-swipe-move-y) tw:data-[swipe=end]:translate-y-(--reka-toast-swipe-end-y) tw:data-[swipe=cancel]:translate-y-0"
    }
  ],
  "defaultVariants": {
    "position": "bottom-right" as typeof position[number]
  }
}